export const downloadFile = (filename, data) => {
  const link = document.createElement('a')
  link.style = 'display: none;'

  const blob = new Blob([data])

  link.href = window.URL.createObjectURL(blob)
  link.download = filename

  document.body.appendChild(link)
  link.click()

  setTimeout(() => {
    document.body.removeChild(link)
    window.URL.revokeObjectURL(link.href)
  }, 100)
}

export const downloadFileUrl = async (filename, href) => {
  console.log(filename,  href)
  let link = document.createElement('a')

  const blob = await fetch(href).then(r =>
    r.blob().then(i => {
      link.setAttribute('href', URL.createObjectURL(i))
      link.setAttribute('download', filename)
      link.target = '_blank'

      document.body.appendChild(link)
      link.click()
    })
  )


  setTimeout(() => {
    document.body.removeChild(link)
    window.URL.revokeObjectURL(link.href)
  }, 100)
}

// TODO wait jl fix https certificat
export const downloadFileUrlWithoutBlob = async (filename, href) => {
  let link = document.createElement('a')

  link.href = href
  link.target = '_blank'
  link.download = filename

  document.body.appendChild(link)
  link.click()

  setTimeout(() => {
    document.body.removeChild(link)
    window.URL.revokeObjectURL(link.href)
  }, 100)
}
